import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

export const SUPPORTED_LANGS = ["fr", "en", "es", "it", "zh", "ru", "ht", "de"];
export const DEFAULT_LANG = "fr";

export const LANG_META = {
  fr: { label: "Français", short: "FR", flag: "🇫🇷", iso: "FR" },
  en: { label: "English", short: "EN", flag: "🇬🇧", iso: "GB" },
  es: { label: "Español", short: "ES", flag: "🇪🇸", iso: "ES" },
  it: { label: "Italiano", short: "IT", flag: "🇮🇹", iso: "IT" },
  zh: { label: "中文", short: "ZH", flag: "🇨🇳", iso: "CN" },
  ru: { label: "Русский", short: "RU", flag: "🇷🇺", iso: "RU" },
  ht: { label: "Kreyòl", short: "HT", flag: "🇭🇹", iso: "HT" },
  de: { label: "Deutsch", short: "DE", flag: "🇩🇪", iso: "DE" },
};

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
// Cache-buster: re-fetched on every page load so a new deployment forces
// the i18n payload to refresh client-side (otherwise the browser/HTTP cache
// can keep serving the old translation dict after a redeploy).
const I18N_CB = Date.now();

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    ns: ["common"],
    defaultNS: "common",
    backend: {
      // Loads from /api/i18n/ui/{lng} (backend returns the full UI dict for the language)
      loadPath: `${API_BASE}/api/i18n/ui/{{lng}}?cb=${I18N_CB}`,
      parse: (data) => {
        try {
          return JSON.parse(data);
        } catch {
          return {};
        }
      },
    },
    detection: {
      // Path is authoritative (set by LangSync). For unprefixed visits, we
      // prefer the user's explicit choice in localStorage and fall back to
      // FR — never the navigator language — so the canonical default is
      // deterministic for first-time visitors.
      order: ["path", "localStorage"],
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
